<footer class="template-footer mt-10  ">
  <div class="footer-inner bg-size-cover bg-color-grey" style="
       background-size: auto;
       /* background-image: url(../../../../assets/app-assets/images/fotografias/fund-rodape.png); */
     ">
    <div class="container-fluid">
      <div class="p-2">
        <div class="row">
          <div class="col-lg-2 col-sm-6">
            <div class="justify-content-lg-center">
              <h5 class="title-footer cursor-pointer" (click)="navigateToSection('about-geia')"><b>A GÉIA</b></h5>
              <h5 class="sub-title-footer cursor-pointer" (click)="navigateToSection('about-geia')"><b>Quem Somos</b>
              </h5> 

              <h5 (click)="navigateToSection('integridade-compliance')"
                class="sub-title-footer mt-footer cursor-pointer">
                <b>Integridade e Compliance</b>
              </h5>
              <h5 (click)="navigateToSection('projetos-e-programas')" class="sub-title-footer mt-footer cursor-pointer">
                <b>Projetos e Programas</b>
              </h5> 

              <h5 class="sub-title-footer mt-footer"><b>Blog</b></h5>

              <h5 class="sub-title-footer mt-footer"><b>LGPD</b></h5> 
            </div>

            <div class="justify-content-lg-center mt-2">
              <h5 class="title-footer "><b>PARA VOCÊ</b></h5>
              <h5 class="sub-title-footer"><b>Benefícios</b></h5>
              <ul class="unstyled">
                <li><a href="https://portal.geia.com.br/unimedfesp" class="text-color cursor-pointer">Saúde</a></li>
                <li><a href="https://portal.geia.com.br/unimedodonto" class="text-color cursor-pointer">Odontológico</a>
                </li>
              </ul>

              <h5 class="sub-title-footer mt-footer"> <a class="text-color"
                  href="https://www.portal.geia.com.br/seguroauto"><b>Seguros</b></a>
              </h5> 
            </div>
          </div>


          <div class="col-lg-2 col-sm-6">
            <div class="justify-content-lg-center">
              <h5 class="title-footer cursor-pointer" (click)="navigateToSection('geia-empresa')"><b>PARA SUA
                  EMPRESA</b></h5>
              <h5 class="sub-title-footer"><b>Benefícios</b></h5>
              <ul class="unstyled">
                <li><a class="text-color">Saúde</a></li>
                <li><a class="text-color" (click)="navigateToSection('geia-empresa')">Odontológico</a></li>
              </ul>

              <h5 class="sub-title-footer mt-footer cursor-not-allowed">
                <b>Seguros Corporativos</b>
              </h5> 
              <h5 class="title-footer"><br /></h5>
              <h5 class="sub-title-footer cursor-not-allowed"><b>Demais Serviços</b></h5>
              <ul class="unstyled">
                <li>
                  <a (click)="navigateToSection('geia-empresa')" class="text-color cursor-not-allowed">Gerenciamento de
                    Risco e Gestão de Saúde</a>
                </li>
                <li><a (click)="navigateToSection('geia-empresa')" class="text-color ">Teleorientação </a></li>
                <li>
                  <a (click)="navigateToSection('geia-empresa')" class="text-color cursor-not-allowed">Vale
                    Refeição/Alimentação
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-sm-6">
            <div class="justify-content-lg-center">
              <h5 class="title-footer cursor-not-allowed"><b>ÁREA DE LOGIN</b></h5>
              <h5 class="sub-title-footer"> <a class="cursor-pointer text-color" [routerLink]="['/cliente']"> <b>Espaço
                    Cliente</b></a></h5>
              <ul class="unstyled">
                <li><a href="https://geia.facilinformatica.com.br/Administracao/Login.aspx"
                    class="text-color cursor-pointer">Boletos</a></li>
                <li><a href="https://geia.facilinformatica.com.br/Administracao/Login.aspx"
                    class="text-color cursor-pointer">Informe de Rendimento </a></li>
                <li><a href="https://tetis.geia.com.br/Account/logincorretor"
                    class="text-color cursor-pointer"><b>Espaço Corretor</b></a></li>
                <li><a href="https://portal.geia.com.br/conta/loginentidade" class="text-color cursor-pointer"><b>Espaço
                      Entidade</b></a></li>
                <li><a href="https://portal.geia.com.br/conta/loginrh" class="text-color cursor-pointer"><b>Espaço
                      RH</b></a></li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-sm-6" style="margin-top: -7px;">
            <div class="justify-content-lg-center">
              <ul class="nav-links">
                <p class="text-color font-12">
                  <b>Av. Valdemar Ferreira, 463 - Butantã, São Paulo - SP,
                    05501-000</b>
                </p>
                <p class="text-color font-12">
                  <b>Atendimento:</b><br />
                  (11) 3660-2000
                </p>
                <p class="text-color font-12">
                  <b>Compre pelo Chat:</b> Segunda a sexta 8h30 às 17h30.
                  (exceto feriados)
                </p>
                <p class="text-color font-12 mb-footer">
                  <b>Redes Sociais</b>
                </p>
                <div class="row instagram-images d-flex justify-content-center justify-content-sm-start icones-social-media">
                  <div class="col-6 col-sm-3 col-lg-3 col-sm-3">
                    <a href="https://www.facebook.com/ConsultoriaGeia/?locale=pt_BR" target="_blank">
                      <img class="social-icon" width="32px" src="../../../../assets/app-assets/images/logo/externos/facebook.png"
                        alt="facebook" />
                    </a>
                  </div>
                  <div class="col-6 col-sm-3 col-lg-3 col-sm-3">
                    <a href="https://www.instagram.com/geiaconsultoria/" target="_blank">
                      <img class="social-icon" width="32px" src="../../../../assets/app-assets/images/logo/externos/instagram.png"
                        alt="Instagram" />
                    </a>
                  </div>
                  <div class="col-6 col-sm-3 col-lg-3 col-sm-3">
                    <a href="	https://br.linkedin.com/company/geiaconsultoria" target="_blank">
                      <img class="social-icon" width="32px" src="../../../../assets/app-assets/images/logo/externos/linkedin.png"
                        alt="linkedin" />
                    </a>
                  </div>
                  <div class="col-6 col-sm-3 col-lg-3 col-sm-3">
                    <a href="https://www.youtube.com/@GeiaConsultoria" target="_blank">
                      <img class="social-icon" width="32px" src="../../../../assets/app-assets/images/logo/externos/youtube.png"
                        alt="youtube" />
                    </a>
                  </div>
                </div>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-8 col-sm-6 d-flex justify-content-center">
            <div class="text-widget">
              <div class="footer-logo">
                <img width="150px !Important" src="../../../../../../assets/app-assets/images/ilustracao/ans-rodape-2024.png"
                  alt="geia" />
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="text-widget">
              <div class="footer-logo">
                <img width="126px !Important" src="../../../../assets/app-assets/images/logo/logo-susep.png"
                  alt="susep" />
              </div>

              <ul class="unstyled">
                <li>
                  <span class="text-color">
                    Sandra Maria Lima de Oliveira – Diretora Responsável
                    SUSEP , sob o nº 202094358 Política Institucional de
                    Conduta – Resolução n° 382/2020 – SUSEP.</span>
                </li>
              </ul>
            </div>
          </div>

        </div>
        <div class="row align-items-center justify-content-center col-sm-12 mt-2">
          <img width="130px" src="../../../../assets/app-assets/images/logo/logo-b-geia.png" alt="Instagram" />
        </div>
        <div class="copyright-area">
          <p class="text-color" style="font-size: 11px;">
            <a class="text-color">
              © {{ ano }} GÉIA. TODOS OS DIREITOS RESERVADOS. CNPJ:
              60.899.291/0001-23 - RUA VALDEMAR FERREIRA, 463 - SÃO PAULO -
              SP</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>